export default "__VITE_ASSET__CN_voepa__"